
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./DeOiler.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";

import { trackPageVisit } from "../competency/PageTracker";




 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }

       

function DeOiler() {

        useEffect(() => {
    
      trackPageVisit("DeOiler");
    
    }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);

        const isXV_2801Open = valves?.XV_2801 === false;

   
  const DEFAULT_VALVES = {
  FCV_2801: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2802: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2803: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2804: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2805: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("DeOiler_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2801: { ...DEFAULT_VALVES.FCV_13001, ...parsed.FCV_2801 },
      FCV_2802: { ...DEFAULT_VALVES.FCV_13003, ...parsed.FCV_2802 },
      FCV_2803: { ...DEFAULT_VALVES.FCV_13003, ...parsed.FCV_2803 },
      FCV_2804: { ...DEFAULT_VALVES.FCV_13003, ...parsed.FCV_2804 },
      FCV_2805: { ...DEFAULT_VALVES.FCV_13003, ...parsed.FCV_2805 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("DeOiler_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= AIR COOLER PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };

// ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= INFLOW LOGIC from FIRST STAGE SEPARATOR to SECOND STAGE SEPARATOR CRUDE LEVEL TRANSMITTER =================
     

          // ================= CRUDE FLOW from 3 STAGE SEPARATORS to DE-OILER VESSELS =================
              const [FIC_2803, setFIC_2803] = useState(() => {
                return Number(localStorage.getItem("FIC_2803")) || 0;
              });   
              const targetFIC_2803 = useMemo(() => {
                const fic = Number(transmitters?.FIC_13006 ?? 0) + Number(transmitters?.FIC_12006 ?? 0) + Number(transmitters?.FIC_14006 ?? 0) + Number(transmitters?.FIC_15006 ?? 0) + Number(transmitters?.FIC_18003 ?? 0);
                return valves?.XV_2801 === false ? fic : 0.03;
              }, [transmitters?.FIC_13006, transmitters?.FIC_12006, transmitters?.FIC_14006, transmitters?.FIC_15006, valves?.XV_2801]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setFIC_2803(prev => {
                    const diff = targetFIC_2803 - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetFIC_2803;
        
                    return prev + step;
                  });
                }, 200); // update speed
        
                return () => clearInterval(interval);
              }, [targetFIC_2803]);
        
              useEffect(() => {
                    localStorage.setItem("FIC_2803", FIC_2803);
                  }, [FIC_2803]);


  // ================= WATER FLOW from H2S SCAVENGER to DE-OILER VESSEL =================
              const [FIC_2801, setFIC_2801] = useState(() => {
                return Number(localStorage.getItem("FIC_2801")) || 0;
              });   
              const targetFIC_2801 = useMemo(() => {
                const fic = Number(transmitters?.FIC_2105 ?? 0);
                return valves?.XV_2801 === false ? fic : 0.03;
              }, [transmitters?.FIC_2105, valves?.XV_2801]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setFIC_2801(prev => {
                    const diff = targetFIC_2801 - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetFIC_2801;
        
                    return prev + step;
                  });
                }, 200); // update speed
        
                return () => clearInterval(interval);
              }, [targetFIC_2801]);
        
              useEffect(() => {
                    localStorage.setItem("FIC_2801", FIC_2801);
                  }, [FIC_2801]);


          const FIC_2802 = isXV_2801Open ? (FIC_2801 + FIC_2803) : 0;

                  useEffect(() => {
                    localStorage.setItem("FIC_2802", FIC_2802);
                  }, [FIC_2802]);

          
  // ================= PRESSURES FROM DE-OILER VESSEL =================
                const rawPressures = [
                    transmitters?.PT_2105,
                    transmitters?.PT_13002,
                    transmitters?.PT_12002,
                    transmitters?.PT_14002,
                    transmitters?.PT_15002,
                  ];

                  const pressures = rawPressures
                    .map(v => Number(v))
                    .filter(v => !isNaN(v));

                  const meanPressure =
                    pressures.length > 0
                      ? pressures.reduce((sum, val) => sum + val, 0) / pressures.length
                      : 0;

                  const PT_2801 = meanPressure * 0.032;

                  const PT_2802 =  PT_2801 * 0.6;

                  const PT_2804 =  PT_2802 * 0.9;
                  const PT_2803 =  1.37 * (valveData?.FCV_2804?.opening || 0)/100;

                  const FIC_2804 = (FIC_2802 * 0.00012) * (valveData?.FCV_2801?.opening || 0);
              
             
        useEffect(() => {
            localStorage.setItem("FIC_2804", FIC_2804);
          }, [FIC_2804]);

                 const v1 = Number(transmitters?.TT_13006a);
                const v2 = Number(transmitters?.TT_12006a);
                const v3 = Number(transmitters?.TT_14006a);
                const v4 = Number(transmitters?.TT_15006a);
                const v5 = Number(transmitters?.TT_2105);

                let sum = 0;
                let count = 0;

                if (v1 > 0) { sum += v1; count++; }
                if (v2 > 0) { sum += v2; count++; }
                if (v3 > 0) { sum += v3; count++; }
                if (v4 > 0) { sum += v4; count++; }
                if (v5 > 0) { sum += v5; count++; }

                const TT_2801 = count > 0 ? sum / count : 24;

                const TT_2802 = TT_2801 < 0.5 ? 24 : TT_2801 * 0.98;
            
// =================  DECREMENTING LEVEL OF DE-OILER VESSEL CRUDE CHAMBER =================


      const crudeFlowRateDeOiler = 20 * 0.985;
       const FIC_2807 = crudeFlowRateDeOiler * ((valveData?.FCV_2804?.opening || 0) / 100);


      const { setTransmitters } = useContext(WellContext);
      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          FIC_2807: FIC_2807
        }));
      }, [FIC_2807]);

    
      // =================  DECREMENTING LEVEL OF DE-OILER 1 VESSEL WATER CHAMBER =================

      const isXV_2802Open = valves?.XV_2802 === false;

      const waterFlowRateDeOiler = isXV_2802Open ? 150 * 0.893 : 0;
       const FIC_2806 = isXV_2802Open ? waterFlowRateDeOiler * ((valveData?.FCV_2803?.opening || 0) / 100) : 0;


      // =================  DECREMENTING LEVEL OF DE-OILER 2 VESSEL WATER CHAMBER =================


      const waterFlowRateDeOiler2 = FIC_2806 * 0.993;
       const FIC_2808 = 50;

    


      const FIC_2805 = FIC_2806 * 0.007 * ((valveData?.FCV_2802?.opening || 0) / 100)

              useEffect(() => {
            localStorage.setItem("FIC_2805", FIC_2805);
          }, [FIC_2805]);

      // ================= DE-OILER VESSEL INFLOW / OUTFLOW LOGIC =================

        // --- VALVE STATUS ---

        // --- INLETS FROM OTHER UNITS ---
        const f1 = Number(transmitters?.FIC_13006 ?? 0);
        const f2 = Number(transmitters?.FIC_12006 ?? 0);
        const f3 = Number(transmitters?.FIC_14006 ?? 0);
        const f4 = Number(transmitters?.FIC_15006 ?? 0);
        const f5 = Number(transmitters?.FIC_2105 ?? 0);

        // --- TOTAL INLET (ONLY IF VALVE IS OPEN) ---
        const totalInlet = isXV_2801Open ? (f1 + f2 + f3 + f4 + f5) : 0;

        // --- SPLIT ---
        const crudeInflow = totalInlet * 0.10;
        const waterInflow = totalInlet * 0.89;

              // --- FORMAT FOR LEVEL COMPONENT ---
        const crudeInflows = crudeInflow > 0 ? [crudeInflow / 3] : [];
        const waterInflows = waterInflow > 0 ? [waterInflow / 30] : [];

        const crudeOutflows = FIC_2807 > 0 ? [FIC_2807 / 3] : [];
        const waterOutflows = FIC_2806 > 0 ? [FIC_2806 / 16] : [];

  

      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          FIC_2808: FIC_2808
        }));
      }, [FIC_2808]);

            useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          TT_2802: TT_2802
        }));
      }, [TT_2802]);
        


      // ================= PUMP CONTEXT =================
      const { pumpData } = useContext(PumpContext);

      // ================= PUMPS =================
      const isPumpAOn = pumpData?.["P-280A"]?.running ?? false;
      const isPumpBOn = pumpData?.["P-280B"]?.running ?? false;

      // =====================================================
// DeOiler Page
// SAVE PUMP STATUS TO localStorage
// =====================================================

useEffect(() => {
  localStorage.setItem(
    "P280A_RUNNING",
    isPumpAOn
  );

  localStorage.setItem(
    "P280B_RUNNING",
    isPumpBOn
  );
}, [isPumpAOn, isPumpBOn]);


      const runningPumps = [isPumpAOn, isPumpBOn].filter(Boolean).length;

      // ================= INPUTS =================
      const baseFlow  = Number(transmitters?.FIC_2808 ?? 0);
      const suctionPressure = Number(transmitters?.PT_2804 ?? 0);
      const suctionTemp = Number(transmitters?.TT_2802 ?? 0);
      const suctionFlow = runningPumps > 0
          ? baseFlow * (runningPumps / 2)   // 1 pump = 50%, 2 pumps = 100%
          : 0;

// ================= VALVE =================
const valveOpeningRaw = Number(valveData?.FCV_2805?.opening ?? 0);

// Clamp 0–100
const valveOpening = Math.max(0, Math.min(100, valveOpeningRaw));

      

      // ================= INTERLOCK =================
const pumpsAllowed = suctionFlow > 0 && runningPumps > 0;

// ================= TABLES =================
const flowTable = {
  0: 0, 10: 1.1, 20: 1.2, 30: 1.3, 40: 1.4,
  50: 1.5, 60: 1.6, 70: 1.7, 80: 1.8, 90: 1.9, 100: 2
};

const tempTable = {
  0: 5, 10: 1.3, 20: 1.1, 30: 1.08, 40: 1.075,
  50: 1.07, 60: 1.065, 70: 1.06, 80: 1.05, 90: 1.04, 100: 1.03
};

const pressureTable = {
  0: 7, 10: 1.9, 20: 1.6, 30: 1.2, 40: 1.15,
  50: 1.08, 60: 1.06, 70: 1.05, 80: 0.89, 90: 0.8, 100: 1.079
};

// ================= INTERPOLATION =================
const interpolate = (value, table) => {
  const keys = Object.keys(table).map(Number).sort((a, b) => a - b);

  if (table[value] !== undefined) return table[value];

  let lower = 0;
  let upper = 100;

  for (let i = 0; i < keys.length - 1; i++) {
    if (value >= keys[i] && value <= keys[i + 1]) {
      lower = keys[i];
      upper = keys[i + 1];
      break;
    }
  }

  const ratio = (value - lower) / (upper - lower);

  return table[lower] + ratio * (table[upper] - table[lower]);
};

// ================= MULTIPLIERS =================
const flowMultiplier = interpolate(valveOpening, flowTable);
const tempMultiplier = interpolate(valveOpening, tempTable);
const pressureMultiplier = interpolate(valveOpening, pressureTable);

 
// ================= FLOW =================
const FIC_2809 = pumpsAllowed
  ? suctionFlow * flowMultiplier
  : 0;

// ================= PRESSURE =================
const [PT_2805, setPT_2805] = useState(() => {
  const saved = localStorage.getItem("PT_2805");
  return saved !== null ? Number(saved) : 0.03;
});

useEffect(() => {
  const interval = setInterval(() => {
    setPT_2805(prev => {

      if (!pumpsAllowed) return 0;

      // EXACT BASE: 1.2 × multiplier
      const target = 1.2 * pressureMultiplier;

      return prev + (target - prev) * 2.15;
    });
  }, 200);

  return () => clearInterval(interval);
}, [pumpsAllowed, pressureMultiplier]);

// ================= TEMPERATURE =================
const [TT_2805, setTT_2805] = useState(() => {
  const saved = localStorage.getItem("TT_2805");
  return saved !== null ? Number(saved) : 22;
});


useEffect(() => {
  const interval = setInterval(() => {
    setTT_2805(prev => {

      if (!pumpsAllowed) return 0;

      const target = suctionTemp * tempMultiplier;

      return prev + (target - prev) * 0.15;
    });
  }, 200);

  return () => clearInterval(interval);
}, [pumpsAllowed, suctionTemp, tempMultiplier]);


           // ================= PUSH TO GLOBAL =================
      useEffect(() => {
                    localStorage.setItem("FIC_2809", FIC_2809);
                  }, [FIC_2809]);
      useEffect(() => {
                    localStorage.setItem("PT_2805", PT_2805);
                  }, [PT_2805]);
      useEffect(() => {
                    localStorage.setItem("TT_2805", TT_2805);
                  }, [TT_2805]);


                  // =================  INFLOW AND OUTFLOW OF DE-OILER 2 VESSEL WATER CHAMBER =================

       const lt2802Inflows  = FIC_2806 > 0 ? [FIC_2806 / 30] : [];
      const lt2802Outflows = suctionFlow  > 0 ? [suctionFlow  / 16] : [];


  return (
    <div className="DeOiler-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "253px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "2px 283px"
      }}>
        DE-OILER VESSELS
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2801 */}
      <Valve
        className="XV-2801"
        tag="XV_2801"
        x={312}
        y={200}
        isClosed={valves.XV_2801}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2802 */}
      <Valve
        className="XV-2802"
        tag="XV_2802"
        x={408}
        y={441}
        isClosed={valves.XV_2802}
        toggle={toggleValve}
      />

      
      

      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2801 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2801"
          style={{ position: "absolute", left: 406, top: 130, transform: "rotate(90deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_2801")}>
          
          <defs>
            <linearGradient id="metal_2801">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2801)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2801)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-2802 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2802"
          style={{ position: "absolute", left: 898, top: 148, transform: "rotate(90deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_2802")}>
          
          <defs>
            <linearGradient id="metal_2802">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2802)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2802)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>



        {/* FCV-2803 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2803"
          style={{ position: "absolute", left: 562, top: 433 }}  onClick={() => openPanel("FCV_2803")}>
          
          <defs>
            <linearGradient id="metal_2803">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2803)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2803)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>


        {/* FCV-2804 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2804"
          style={{ position: "absolute", left: 385, top: 517 }}  onClick={() => openPanel("FCV_2804")}>
          
          <defs>
            <linearGradient id="metal_2804">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2804)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2804)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          

        {/* FCV-2805 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2805"
          style={{ position: "absolute", left: 1167, top: 387, transform: "rotate(90deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_2805")}>
          
          <defs>
            <linearGradient id="metal_2805">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2805)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2805)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

        {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2801?.opening || 0)}
        x={390}
        y={145}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2802?.opening || 0)}
        x={882}
        y={160}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2803?.opening || 0)}
        x={582}
        y={475}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2804?.opening || 0)}
        x={400}
        y={558}
      />
      <ValveOutput
        value={Number(valveData?.FCV_2805?.opening || 0)}
        x={1156}
        y={404}
      />

      <Transmitter
      tag="FIC-2803"
      value={FIC_2803}
      x={188}
      y={213}
      unit="LPM"
        max={500}
        HH={590}
        H={375}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF PRODUCED WATER FROM STAGE SEPARATIONS TO DE-OILER VESSEL"
    />
      <Transmitter
      tag="FIC-2801"
      value={FIC_2801}
      x={95}
      y={145}
      unit="LPM"
        max={200}
        HH={190}
        H={175}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF SOUR WATER FROM H2S SCAVENGER VESSEL TO DE-OILER VESSEL 1"
    />
      <Transmitter
      tag="FIC-2802"
      value={FIC_2802}
      x={187}
      y={144}
      unit="LPM"
        max={500}
        HH={490}
        H={475}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF TOTAL PRODUCED WATER TO DE-OILER VESSEL 1 INLET"
    />
      <Transmitter
      tag="PT-2801"
      value={PT_2801}
      x={266}
      y={144}
      unit="MPa"
        max={3}
        HH={2.5}
        H={1.8}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF TOTAL PRODUCED WATER TO DE-OILER VESSEL 1 INLET"
    />
      <Transmitter
      tag="PT-2802"
      value={PT_2802}
      x={762}
      y={214}
      unit="MPa"
        max={3}
        HH={2.5}
        H={1.8}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF PRODUCED WATER FROM DE-OILER VESSEL 1 TO DE-OILER VESSEL 2"
    />
      <Transmitter
      tag="PT-2803"
      value={PT_2803}
      x={298}
      y={509}
      unit="MPa"
        max={3}
        HH={2.5}
        H={1.8}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF SEPARATED CRUDE FROM DE-OILER VESSEL 1 TO OILY WATER TANK"
    />
      <Transmitter
      tag="PT-2804"
      value={PT_2804}
      x={828}
      y={509}
      unit="MPa"
        max={3}
        HH={2.5}
        H={1.8}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF PRODUCED WATER FROM DISCHARGE OF DE-OILER VESSEL 2 TO WATER PUMPS"
    />
      <Transmitter
      tag="TT-2801"
      value={TT_2801}
      x={495}
      y={214}
      unit="°C"
        max={70}
        HH={68}
        H={57}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF DE-OILER VESSEL 1"
    />
      <Transmitter
      tag="TT-2802"
      value={TT_2802}
      x={989}
      y={214}
      unit="°C"
        max={70}
        HH={68}
        H={57}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF DE-OILER VESSEL 2"
    />

      <Transmitter
      tag="FIC-2804"
      value={FIC_2804}
      x={446}
      y={111}
      unit="SCF/S"
       max={50}
        HH={49}
        H={45}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF RECOVERED GAS FROM DE-OILER VESSEL 1 TO FLARE HEADER"
    />
      <Transmitter
      tag="FIC-2805"
      value={FIC_2805}
      x={945}
      y={111}
      unit="SCF/S"
        max={50}
        HH={49}
        H={45}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF RECOVERED GAS FROM DE-OILER VESSEL 2 TO FLARE HEADER"
    />
      <Transmitter
      tag="FIC-2806"
      value={FIC_2806}
      x={687}
      y={214}
      unit="LPM"
        max={150}
        HH={145}
        H={135}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF PRODUCED WATER FROM DE-OILER VESSEL 1 TO DE-OILER VESSEL 2 INLET"
    />
      <Transmitter
      tag="FIC-2807"
      value={FIC_2807}
      x={224}
      y={509}
      unit="LPM"
        max={30}
        HH={25}
        H={20}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE FROM DE-OILER VESSEL 1 TO OILY WATER TANK"
    />

      <Transmitter
      tag="FIC-2808"
      value={FIC_2808}
      x={829}
      y={445}
      c="transparent"
    />
      <Transmitter
      value={suctionFlow}
      x={829}
      y={545}
      c="transparent"
    />
      <Transmitter
      tag="FIC-2809"
      value={FIC_2809}
      x={1219}
      y={445}
      unit="LPM"
        max={70}
        HH={60}
        H={45}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF PRODUCED WATER FROM DE-OILER VESSEL 2 TO SOUR WATER STRIPPER VIA THE WATER PUMP DISCHARGE"
    />
      <Transmitter
      tag="TT-2805"
      value={TT_2805}
      x={1212}
      y={565}
      unit="°C"
        max={70}
        HH={68}
        H={57}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF PRODUCED WATER FROM DE-OILER VESSEL 2 TO SOUR WATER STRIPPER VIA THE WATER PUMP DISCHARGE"
    />
      <Transmitter
      tag="PT-2805"
      value={PT_2805}
      x={1212}
      y={509}
      unit="MPa"
        max={3}
        HH={2.5}
        H={1.8}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF PRODUCED WATER FROM DE-OILER VESSEL 2 TO SOUR WATER STRIPPER VIA THE WATER PUMP DISCHARGE"
    />

    <LevelTransmitterIndicator
      tag="LT_2801"
      totalLevel={12000}
      inflows={waterInflows}
      outflows={waterOutflows}
      responseFactor={0.05}
      columnX={320}
      columnY={270}
      columnWidth={30}
      columnHeight={105}
      textX={170}
      textY={310}
      showFlow={true}
    />


    <LevelTransmitterIndicator
      tag="LT_2802"
      totalLevel={12000}
      inflows={crudeInflows}
      outflows={crudeOutflows}
      responseFactor={0.05}
      columnX={528}
      columnY={270}
      columnWidth={30}
      columnHeight={105}
      textX={608}
      textY={280}
      showFlow={true}
    />

    <LevelTransmitterIndicator
      tag="LT_2803"
      totalLevel={12000}
      inflows={lt2802Inflows}
      outflows={lt2802Outflows}
      responseFactor={0.05}
      columnX={850}
      columnY={290}
      columnWidth={195}
      columnHeight={100}
      textX={1100}
      textY={300}
      showFlow={true}
    />

    <Pump
      tag="P-280A"
      x={957}
      y={500}
      rpm={1800}
      bladeCount={pumpData?.["P-280A"]?.bladeCount || 3}
      size={pumpData?.["P-280A"]?.size || 37}
      onClick={openPumpPanel}
    />

    <Pump
      tag="P-280B"
      x={957}
      y={600}
      rpm={1800}
      bladeCount={pumpData?.["P-280B"]?.bladeCount || 3}
      size={pumpData?.["P-280B"]?.size || 37}
      onClick={openPumpPanel}
    />





    
    </div>
  );
}

export default DeOiler;